import { Component, ViewChild } from '@angular/core';

import {
  BfluenceIntegrityControllerService,
  DivergentBfluencerStatusCheck
} from 'src/app/admin-api';

import { ConfirmationService, MessageService } from 'primeng/api';
import { lastValueFrom } from 'rxjs';
import { TableColumn, TableComponent } from 'src/app/components/table';
import { AppDialogService } from 'src/app/services/dialog.service';
import { LoaderService } from 'src/app/services/loader.service';

@Component({
  selector: 'app-divergent-bfluencer-status',
  templateUrl: './divergent-bfluencer-status.component.html',
  styleUrl: './divergent-bfluencer-status.component.scss',
  providers: [ConfirmationService, MessageService]
})
export class DivergentBfluencerStatusComponent {
  @ViewChild(TableComponent) table: TableComponent;

  columns: Array<TableColumn> = [
    new TableColumn('', '', false, 'checkbox'),
    new TableColumn('Id', 'divergentBfluencerStatusId', true, 'number'),
    new TableColumn(
      'PersonId',
      'personId',
      true,
      'number',
      '/users/person/',
      'personId'
    ),
    new TableColumn('Name', 'name', true),
    new TableColumn('WrongStatus', 'wrongStatus'),
    new TableColumn('RightStatus', 'rightStatus'),
    new TableColumn('ActualCoupon', 'actualCoupon'),
    new TableColumn('Ativa?', 'enabled', true)
  ];

  constructor(
    public bfluenceIntegrityService: BfluenceIntegrityControllerService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService
  ) {}

  markAsResolved(elements: Array<DivergentBfluencerStatusCheck>): void {
    this.confirmationService.confirm({
      acceptLabel: 'Sim',
      rejectLabel: 'Não',
      rejectButtonStyleClass: 'p-button-danger',
      message: 'Deseja ajustar estas bfluencers?',
      header: 'Ajustar Benefícios',
      accept: async () => {
        LoaderService.showLoader();
        try {
          await lastValueFrom(
            this.bfluenceIntegrityService.fixDivergentBfluenceStatus(elements)
          );
          await this.table.refresh(true);
          this.messageService.add({
            summary: 'Sucesso',
            detail: elements.length + ' marcado(s) como resolvido(s)',
            severity: 'success'
          });
          LoaderService.showLoader(false);
        } catch (error) {
          LoaderService.showLoader(false);
          AppDialogService.showErrorDialog(error);
        }
      }
    });
  }

  syncTableElements(): void {
    this.confirmationService.confirm({
      acceptLabel: 'Sim',
      rejectLabel: 'Não',
      rejectButtonStyleClass: 'p-button-danger',
      message: 'Deseja atualizar a lista?',
      header: 'Atualizar tabela',
      accept: async () => {
        LoaderService.showLoader();
        try {
          await lastValueFrom(
            this.bfluenceIntegrityService.syncDivergentBfluencerStatus()
          );
          await this.table.refresh(true);
          this.messageService.add({
            summary: 'Sucesso',
            detail: 'Tabela atualizada com sucesso!',
            severity: 'success'
          });
          LoaderService.showLoader(false);
        } catch (error) {
          LoaderService.showLoader(false);
          AppDialogService.showErrorDialog(error);
        }
      }
    });
  }
}
